export default {
    state: {
        tabs:[],
        activeTab:""
    },
    mutations: {
        setTabs(state,tabs) {
            state.tabs = tabs;
        },setActiveTab(state,activeTab) {
            state.activeTab = activeTab;
        }
    },
    actions: {
        addTab({ commit, state }, tab) {
            var tabs = state.tabs;
            var existRouter = false;
            for(var index in tabs){
                var tabItem= tabs[index];
                if(tabItem.name == tab.name) {
                    existRouter = true;
                }
            }
            if(!existRouter) {
                tabs.push(tab);
                if(tabs.length>=10) {
                    tabs = tabs.splice(tabs.length-10);
                }
                commit('setTabs', tabs);
            }
        },deleteTab({ commit, state }, routerName) {
            var tabs = state.tabs;
            for(var index in tabs){
                var tabItem= tabs[index];
                if(tabItem.name == routerName) {
                    tabs.splice(index,1);
                    commit('setTabs', tabs);
                    break;
                }
            }
        },setActiveTab({ commit, state }, activeTab) {
            commit('setActiveTab', activeTab);
        },clearHeadTab({ commit, state }) {
            commit('setTabs', []);
            commit('setActiveTab', "");
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/headTab.js